module.exports = __webpack_public_path__ + "img/NE.7e9bf495.svg";